import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { WebVitalsParams } from './events.types';

type WebVitalsMetric = {
    name: WebVitalsParams['metric_name'];
    value: number;
    id: string;
    rating: WebVitalsParams['rating'];
};

@Injectable({ providedIn: 'root' })
export class WebVitalsService {
    private readonly analytics = inject(AnalyticsService);
    private started = false;

    async start(): Promise<void> {
        if (this.started) return;
        this.started = true;
        try {
            const vitals = await import('web-vitals');
            const report = (m: WebVitalsMetric) => {
                this.analytics.track('web_vitals', {
                    metric_name: m.name,
                    value: Math.round(m.name === 'CLS' ? m.value * 1000 : m.value),
                    metric_id: m.id,
                    rating: m.rating
                });
            };
            vitals.onLCP(report);
            vitals.onINP(report);
            vitals.onCLS(report);
            vitals.onFCP(report);
            vitals.onTTFB(report);
        } catch {
            // Falha de carregamento do módulo — silencioso (ad blocker, offline, etc.).
        }
    }
}
